const actionTypeIdentifier = '1DA8E5EB-A48B-4400-8816-35D93785D144';

export const getInvoiceDisputeComments = `DISPUTE-GET-INVOICE-DISPUTE-COMMENTS${actionTypeIdentifier}`;
export const setInvoiceDisputeError = `DISPUTE-SET-INVOICE-DISPUTE-ERROR${actionTypeIdentifier}`;
export const resetInvoiceDisputeComments = `RESET-INVOICE-DISPUTE-COMMENTS${actionTypeIdentifier}`;
export const insertInvoiceDisputeComments = `INSERT-INVOICE-DISPUTE-COMMENTS${actionTypeIdentifier}`;
export const deleteInvoiceDisputeComments = `DELETE-INVOICE-DISPUTE-COMMENTS${actionTypeIdentifier}`;

